import React from 'react';
import cn from 'classnames';
import { FormattedMessage } from 'react-intl';
import { array, func, number, string, oneOfType } from 'prop-types';
import LimitsListItem from './LimitsListItem';

const propTypes = {
  limits: array.isRequired,
  onLimitChange: func.isRequired,
  activeLimit: oneOfType([number, string]).isRequired,
  className: string,
};

const defaultProps = {
  limits: [],
};

const LimitsList = ({ limits, onLimitChange, activeLimit, className, title }) => {
  return (
    <ul className={cn('limits-list', className)}>
      <li className=" limits-label limits-label-mobile">
        <span className="limits-label">
          {title ? (
            title
          ) : (
            <FormattedMessage id="offers.limits" defaultMessage="Строк на странице" />
          )}
        </span>
      </li>
      <div className="limits-list-items">
        {limits.map((limit) => (
          <LimitsListItem
            key={`limit_${limit}`}
            onClick={onLimitChange}
            active={activeLimit === limit || (!limits.includes(activeLimit) && limit === 'All')}
            limit={limit}
          />
        ))}
      </div>
    </ul>
  );
};

LimitsList.propTypes = propTypes;
LimitsList.defaultProps = defaultProps;

export default LimitsList;
